<template><section><h2>Nightingle Rose Chart 南丁格尔玫瑰图</h2>
<block-demo tip="" source="const data = [
  { value: 335, name: &#39;直接访问&#39; },
  { value: 310, name: &#39;邮件营销&#39; },
  { value: 280, name: &#39;联盟广告&#39; },
  { value: 254, name: &#39;视频广告&#39; },
  { value: 200, name: &#39;搜索引擎&#39; }
]
const { Chart, Pie, Tooltip, Legend } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

chart.source(data, {
  row: &#39;name&#39;,
  value: &#39;value&#39;
})

const pie = new Pie({
  radius: 0.7,
  pos: [0, 0],
  size: [&#39;80%&#39;, &#39;100%&#39;],
  rose: true
})
pie.style(&#39;guideline&#39;, true)
pie.style(&#39;guideText&#39;, { fontSize: &#39;12px&#39; })

const legend = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;center&#39;] })
legend.style(&#39;icon&#39;, (attrs, d, i) =&gt; ({
  borderRadius: 10,
  marginTop: i &gt; 0 ? 15 : 0
}))
legend.style(&#39;text&#39;, (attrs, d, i) =&gt; ({
  marginTop: i &gt; 0 ? 15 : 0
}))

chart.append(pie)
chart.append(legend)
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">335</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'直接访问'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">310</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'邮件营销'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">280</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'联盟广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">254</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'视频广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">200</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'搜索引擎'</span> }
]
<span class="hljs-keyword">const</span> { Chart, Pie, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'name'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>
})

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.7</span>,
  <span class="hljs-attr">pos</span>: [<span class="hljs-number">0</span>, <span class="hljs-number">0</span>],
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'80%'</span>, <span class="hljs-string">'100%'</span>],
  <span class="hljs-attr">rose</span>: <span class="hljs-literal">true</span>
})
pie.style(<span class="hljs-string">'guideline'</span>, <span class="hljs-literal">true</span>)
pie.style(<span class="hljs-string">'guideText'</span>, { <span class="hljs-attr">fontSize</span>: <span class="hljs-string">'12px'</span> })

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>] })
legend.style(<span class="hljs-string">'icon'</span>, (attrs, d, i) =&gt; ({
  <span class="hljs-attr">borderRadius</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">marginTop</span>: i &gt; <span class="hljs-number">0</span> ? <span class="hljs-number">15</span> : <span class="hljs-number">0</span>
}))
legend.style(<span class="hljs-string">'text'</span>, (attrs, d, i) =&gt; ({
  <span class="hljs-attr">marginTop</span>: i &gt; <span class="hljs-number">0</span> ? <span class="hljs-number">15</span> : <span class="hljs-number">0</span>
}))

chart.append(pie)
chart.append(legend)
</code></pre>
</block-demo><h3>设定角度</h3>
<block-demo tip="" source="const data = [
  { value: 335, name: &#39;直接访问&#39; },
  { value: 310, name: &#39;邮件营销&#39; },
  { value: 280, name: &#39;联盟广告&#39; },
  { value: 254, name: &#39;视频广告&#39; },
  { value: 200, name: &#39;搜索引擎&#39; }
]
const { Chart, Pie, Axis, Tooltip, Legend } = qcharts

const chart = new Chart({ container: &#39;#app&#39; })

chart.source(data, {
  row: &#39;name&#39;,
  value: &#39;value&#39;
})

const pie = new Pie({
  size: [360, 360],
  radius: 1,
  rose: true,
  startAngle: Math.PI * 1,
  endAngle: Math.PI * 1.5
})
pie.style(&#39;text&#39;, true)

const legend = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;center&#39;] })
legend.style(&#39;icon&#39;, (attrs, d, i) =&gt; ({
  borderRadius: 10,
  marginTop: i &gt; 0 ? 15 : 0
}))
legend.style(&#39;text&#39;, (attrs, d, i) =&gt; ({
  marginTop: i &gt; 0 ? 15 : 0
}))

const axisBottom = new Axis()
const axisLeft = new Axis({
  orient: &#39;right&#39;,
  grid: true,
  coord: &#39;polar&#39;,
  coordPos: [&#39;100%&#39;, &#39;100%&#39;]
})

chart.append(pie)
chart.append([legend, axisBottom, axisLeft])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">335</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'直接访问'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">310</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'邮件营销'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">280</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'联盟广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">254</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'视频广告'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">200</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'搜索引擎'</span> }
]
<span class="hljs-keyword">const</span> { Chart, Pie, Axis, Tooltip, Legend } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({ <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span> })

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'name'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>
})

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">size</span>: [<span class="hljs-number">360</span>, <span class="hljs-number">360</span>],
  <span class="hljs-attr">radius</span>: <span class="hljs-number">1</span>,
  <span class="hljs-attr">rose</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">startAngle</span>: <span class="hljs-built_in">Math</span>.PI * <span class="hljs-number">1</span>,
  <span class="hljs-attr">endAngle</span>: <span class="hljs-built_in">Math</span>.PI * <span class="hljs-number">1.5</span>
})
pie.style(<span class="hljs-string">'text'</span>, <span class="hljs-literal">true</span>)

<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>] })
legend.style(<span class="hljs-string">'icon'</span>, (attrs, d, i) =&gt; ({
  <span class="hljs-attr">borderRadius</span>: <span class="hljs-number">10</span>,
  <span class="hljs-attr">marginTop</span>: i &gt; <span class="hljs-number">0</span> ? <span class="hljs-number">15</span> : <span class="hljs-number">0</span>
}))
legend.style(<span class="hljs-string">'text'</span>, (attrs, d, i) =&gt; ({
  <span class="hljs-attr">marginTop</span>: i &gt; <span class="hljs-number">0</span> ? <span class="hljs-number">15</span> : <span class="hljs-number">0</span>
}))

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis()
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({
  <span class="hljs-attr">orient</span>: <span class="hljs-string">'right'</span>,
  <span class="hljs-attr">grid</span>: <span class="hljs-literal">true</span>,
  <span class="hljs-attr">coord</span>: <span class="hljs-string">'polar'</span>,
  <span class="hljs-attr">coordPos</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
})

chart.append(pie)
chart.append([legend, axisBottom, axisLeft])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>